import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callGetDiscounts, callDeleteDiscounts } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { encodeBase64 } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import Swal from "sweetalert2";
import { FormatCurrencys, handleGetCookie } from "../../../utils/commonUtil";
import colors from '../../../utils/colors'
import { useLocation, useNavigate } from 'react-router-dom';
import insuranceType from "../../../data/insuranceType"
import SmartTable from "../../../components/common/table-component";

const Index = () => {
	let baseUrl = "/admin/setting/discounts/save";
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', id: null, carriredCode: null, carriredName: null, insuranceType: '', roleStaff: '' });
	const [discountList, setDiscounts] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const location = useLocation();
	useEffect(() => {
		if (location.state?.refresh) {
			loadData();
		}
	}, [location.state]);

	useEffect(() => {
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			console.log("authData", authData?.user?.roleStaff)
			setRequest((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
				roleStaff: authData?.user?.roleStaff
			}));

			loadData();
		}


	}, [request.page, request.maxResult]);

	const loadData = async () => {
		const authData = handleGetCookie('auth');
		console.log("request", request.roleStaff)
		let data = { keyword: request.keyword, page: request.page, maxResult: request.maxResult, insuranceType: authData?.user?.roleStaff == null || authData?.user?.roleStaff == "" ? request.insuranceType : authData?.user?.roleStaff, };
		const rsp = await dispatch(callGetDiscounts(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data.result)
			setDiscounts(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData();
	}

	const handleEdit = (id) => {
		navigate(baseUrl + "/" + encodeBase64(id))
	}

	const handleDelete = (id) => {
		Swal.fire({
			title: t("titleDelete"),
			text: t("confirmDelete"),
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const rsp = await dispatch(callDeleteDiscounts({ id, carriredCode: request.carriredCode, carriredName: request.carriredName }));
					if (rsp?.payload?.responseCode === "00000") {
						Swal.fire({
							icon: "success",
							title: t("success.delete"),
							confirmButtonColor: colors.confirmMessage,
							confirmButtonText: t('close'),
						}).then(() => {
							loadData();
						});
					}
				} catch (error) {
					Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
				}
			}
		});
	}

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.setting.discount")}</h4>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('callcenter.payment.insuranceType')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="insuranceType"
														value={request.insuranceType}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															insuranceType.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
											columns={[
												{ labelKey: "settings.discount.id", key: "id" },
												{ labelKey: "settings.discount.name", key: "name" },
												{ labelKey: "settings.discount.insuranceType", key: "insuranceTypeName" },
												{ labelKey: "settings.discount.validateFrom", key: "validateFrom" },
												{ labelKey: "settings.discount.validateTo", key: "validateTo" },
												{ labelKey: "settings.discount.valueDirection", key: "valueDirection", render: (val) => FormatCurrencys(val) },
												{ labelKey: "settings.discount.valueType", key: "valueType", render: (val) => val === 1 ? t("settings.discount.unit.number") : "%" },
												{ labelKey: "settings.discount.roles", key: "roleName" },
											]}
											data={{ result: discountList }}
											rowKey="id"
											recordsTableFilter={false}
											customPagination={false}
											showRowNumber={false}
											actions={(item) => (<button className="btn btn-primary btn-sm" onClick={() => handleEdit(item.id)}><i className="fas fa-pen"></i></button>)}
										/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
